<template>
  <div class="qrcode Kanit" style="overflow: hidden">
    <v-toolbar dark class="toolbarqrcode"  style="margin-top: 10px;">
      <img :src="BASE_URL + 'static/icon/qrcode.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>สร้าง QR Code</v-toolbar-title>
    </v-toolbar>
    <div class="horizontal-center widthdivstep">
      <!-- Success Message -->
      <v-card v-if="showSuccess" color="grey lighten-2" class="mb-12 pd-10" style="margin-top: 20px;">
        <div v-if="qrcode.length == 1" style="text-align: center; margin-bottom: 20px;">
          <qrcode :value="API_FRONTEND + 'AEDQRcode/' + qrcode[0]['qrcode_id']" style="width: 180px; margin: 0 auto;" :id="'downloadqr'"></qrcode>
        </div>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon type="button" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="generate_id" v-on="on">
              <v-icon style="color: #5f5f5f; font-size: 16px !important;">file_copy</v-icon>
            </v-btn>
          </template>
          <span>Copy Generate ID</span>
        </v-tooltip>

        <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px; margin-top: 20px;"><b>Generate ID:</b> {{generate_id}}</p>

        <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px; margin-top: 20px;">
          <span style="color: red !important;">*</span> สามารถดูข้อมูลที่ทำการสร้างได้จากส่วนของ Report/ข้อมูล QR Code โดยค้นหาจาก Generate ID หรือ
          <span @click="gotodetail" style="color: #a80d00; text-decoration: underline; font-weight: 800;cursor: pointer;">กดที่นี่</span> เพื่อแสดงข้อมูล
        </p>

        <v-btn rounded color="primary" style="color: white; margin-top: 20px;" @click="successQrcode()">สร้าง QR Code ใหม่</v-btn>
      </v-card>

      <!-- Form -->
      <v-card v-else color="grey lighten-2" class="ma-4 pa-2 mb-6 form-card-fixed" style="margin-top: 20px;">
        <v-card-text>
          <!-- รูปแบบการสร้าง -->
          <div class="section-title">รูปแบบการสร้าง</div>

          <v-row no-gutters class="ma-0 pa-0">
            <v-col cols="12" sm="12" md="12">
              <v-radio-group v-model="radioGroup" row style="margin-top: 2px;">
                <v-radio
                  class="my-0 py-0 mr-8"
                  v-for="n in 2"
                  :key="n"
                  :value="n"
                  :label="(n == 1)? 'สร้าง QRcode 1 โค้ด':'สร้าง QRcode จำนวนมาก'"
                  color="#aa0800ff"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row no-gutters class="ma-0 pa-0" v-if="typeCompanyDecode == 'owner'">
            <v-col cols="12" sm="12" md="12">
              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">หน่วยงานเจ้าของเครื่อง AED <span style="color: red !important;">*</span></p>
              <v-select
                :items="itemsCompanyOwner"
                item-text="company_name"
                item-value="company_id"
                v-model="CompanyOwner"
                label="เลือกเจ้าของเครื่อง AED"
                outlined
                hide-details
                single-line
                class="Kanit"
                attach
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                background-color="#fafafa"
              ></v-select>
            </v-col>
          </v-row>

          <v-divider style="margin: 12px 0;"></v-divider>

          <!-- ข้อมูลเพิ่มเติม -->
          <div class="section-title">ข้อมูลเพิ่มเติม</div>

          <div class="form-content-scrollable">
            <!-- ข้อความเมื่อยังไม่เลือก -->
            <div v-if="radioGroup == 0" class="no-selection-message">
              <v-icon color="grey" size="48">mdi-information-outline</v-icon>
              <p style="color: #757575; margin-top: 16px; font-size: 16px;">กรุณาเลือกรูปแบบการสร้าง QR Code ด้านบน</p>
            </div>

            <!-- สร้าง QRcode 1 โค้ด -->
            <div v-if="radioGroup == 1">
              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">หน่วยงานที่ดูแลเครื่อง <span style="color: red !important;">*</span>
                <v-tooltip bottom v-if="itemsCompany.length != 0">
                  <template v-slot:activator="{ on }">
                    <v-icon @click="dialogcreate_company = true" v-on="on" style="font-size: 18px;color: rgb(168, 14, 0);float: right; cursor: pointer;">fas fa-plus-circle</v-icon>
                  </template>
                  <span>สร้างหน่วยงานดูแลเครื่อง</span>
                </v-tooltip>
              </p>
              <v-select
                :items="itemsCompany"
                item-text="company_name"
                item-value="company_id"
                v-model="CompanyMaintenance"
                label="เลือกหน่วยงานที่ดูแลเครื่อง"
                outlined
                hide-details
                single-line
                style="margin-bottom: 10px;"
                v-if="itemsCompany.length != 0"
                background-color="#fafafa"
                dense
              ></v-select>
              <v-btn rounded style="background: #a80e00; color: white; margin-bottom: 10px;" v-else @click="dialogcreate_company = true">
                <v-icon style="font-size: 14px;">fas fa-plus-circle</v-icon> &nbsp; สร้างหน่วยงานดูแลเครื่อง
              </v-btn>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">Serial Number <span style="color: red !important;">*</span></p>
              <v-text-field
                label="Serial Number"
                single-line
                outlined
                hide-details
                v-model="SerialNum"
                style="margin-bottom: 10px;"
                background-color="#fafafa"
                dense
              ></v-text-field>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">วันหมดอายุของ แบตเตอร์รี่ <span style="color: red !important;">*</span></p>
              <v-menu
                v-model="pickerMonthBat"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="ExpireBat"
                    clearable
                    single-line
                    outlined
                    label="วันหมดอายุของ แบตเตอร์รี่"
                    readonly
                    hide-details
                    v-on="on"
                    style="margin-bottom: 10px;"
                    background-color="#fafafa"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ExpireBatPicker"
                  type="month"
                  locale="th"
                  @change="pickerMonthBat = false"
                ></v-date-picker>
              </v-menu>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">วันหมดอายุของ Pad <span style="color: red !important;">*</span></p>
              <v-menu
                v-model="pickerMonthPad"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="ExpirePad"
                    clearable
                    single-line
                    outlined
                    label="วันหมดอายุของ Pad"
                    readonly
                    hide-details
                    v-on="on"
                    style="margin-bottom: 10px;"
                    background-color="#fafafa"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ExpirePadPicker"
                  type="month"
                  locale="th"
                  @change="pickerMonthPad = false"
                ></v-date-picker>
              </v-menu>
            </div>

            <!-- สร้าง QRcode จำนวนมาก -->
            <div v-if="radioGroup == 2">
              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">หน่วยงานที่ดูแลเครื่อง <span style="color: red !important;">*</span>
                <v-tooltip bottom v-if="itemsCompany.length != 0">
                  <template v-slot:activator="{ on }">
                    <v-icon @click="dialogcreate_company = true" v-on="on" style="font-size: 18px;color: rgb(168, 14, 0);float: right; cursor: pointer;">fas fa-plus-circle</v-icon>
                  </template>
                  <span>สร้างหน่วยงานดูแลเครื่อง</span>
                </v-tooltip>
              </p>
              <v-select
                :items="itemsCompany"
                item-text="company_name"
                item-value="company_id"
                v-model="CompanyMaintenance"
                label="เลือกหน่วยงานที่ดูแลเครื่อง"
                outlined
                hide-details
                single-line
                style="margin-bottom: 10px;"
                v-if="itemsCompany.length != 0"
                background-color="#fafafa"
                dense
              ></v-select>
              <v-btn rounded style="background: #a80e00; color: white; margin-bottom: 10px;" v-else @click="dialogcreate_company = true">
                <v-icon style="font-size: 14px;">fas fa-plus-circle</v-icon> &nbsp; สร้างหน่วยงานดูแลเครื่อง
              </v-btn>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">จำนวน Qrcode <span style="color: red !important;">*</span></p>
              <v-text-field
                label="จำนวน Qrcode ที่ต้องการสร้าง"
                single-line
                outlined
                hide-details
                v-model="NumQRcode"
                type=number
                min=1
                style="margin-bottom: 10px;"
                background-color="#fafafa"
                dense
              ></v-text-field>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">วันหมดอายุของ แบตเตอร์รี่ (ถ้ามี)</p>
              <v-menu
                v-model="pickerMonthBat"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="ExpireBat"
                    clearable
                    single-line
                    outlined
                    label="วันหมดอายุของ แบตเตอร์รี่"
                    readonly
                    hide-details
                    v-on="on"
                    style="margin-bottom: 10px;"
                    background-color="#fafafa"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ExpireBatPicker"
                  type="month"
                  locale="th"
                  @change="pickerMonthBat = false"
                ></v-date-picker>
              </v-menu>

              <p style="text-align: left; margin-bottom: 0; color: #000; font-size: 16px">วันหมดอายุของ Pad (ถ้ามี)</p>
              <v-menu
                v-model="pickerMonthPad"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="ExpirePad"
                    clearable
                    single-line
                    outlined
                    label="วันหมดอายุของ Pad"
                    readonly
                    hide-details
                    v-on="on"
                    style="margin-bottom: 10px;"
                    background-color="#fafafa"
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ExpirePadPicker"
                  type="month"
                  locale="th"
                  @change="pickerMonthPad = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </div>
        </v-card-text>
        <v-divider style="margin-bottom: 10px;"></v-divider>
        <v-card-actions style="text-align: center; justify-content: center;">
          <!-- Submit Button -->
          <div>
            <v-btn
              rounded
              color="primary"
              style="color: white;"
              @click="CreateQRcode()"
              v-if="radioGroup == 1"
              :disabled="CompanyMaintenance == '' || SerialNum == '' || ExpireBat == '' || ExpirePad == ''"
            >
              สร้าง QR Code
            </v-btn>
            <v-btn
              rounded
              color="primary"
              style="color: white;"
              @click="CreateQRcode()"
              v-else-if="radioGroup == 2"
              :disabled="CompanyMaintenance == ''"
            >
              สร้าง QR Code
            </v-btn>
            <v-btn
              rounded
              color="primary"
              style="color: white;"
              v-else
              disabled
            >
              สร้าง QR Code
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
    <CreateCompany :dialogcreate_company="dialogcreate_company" typeCompany="maintenance" :headid="CompanyOwner" @closecreate_company="closecreate_company"></CreateCompany>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
import CreateCompany from '@/components/create/create_company_modal'
Vue.component(VueQrcode.name, VueQrcode)
var _ = require('lodash')
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_FRONTEND: process.env.API_FRONTEND,
      pickerMonthBat: false,
      pickerMonthPad: false,
      radioGroup: 0,
      showSuccess: false,
      qrcode: [],
      CompanyMaintenance: '',
      CompanyOwner: '',
      SerialNum: '',
      NumQRcode: 1,
      ExpireBatPicker: new Date().toISOString().substr(0, 7),
      ExpirePadPicker: new Date().toISOString().substr(0, 7),
      itemsCompanyList: [],
      itemsCompanyOwner: [],
      generate_id: '',
      dialogcreate_company: false,
      typeCompanyDecode: '',
      idCompany: ''
    }
  },
  created () {
    this.typeCompanyDecode = this.$store.state.key_object.typeCompany
    this.CompanyOwner = this.$store.state.key_object.idCompany
    this.getCompanyOwner()
    this.getCompanyMaintenance()
  },
  watch: {
    NumQRcode () {
      if (this.NumQRcode > 1000) {
        this.NumQRcode = 1000
        this.$swal( 'ไม่สำเร็จ', 'ไม่ควรเกิน 1000', 'error' )
      }
    },
    CompanyOwner () {
      this.CompanyMaintenance = ''
    }
  },
  components: {
    CreateCompany
  },
  computed: {
    ExpireBat () {
      const [year, month] = this.ExpireBatPicker.split('-')
      return `${month}/${year}`
    },
    ExpirePad () {
      const [year, month] = this.ExpirePadPicker.split('-')
      return `${month}/${year}`
    },
    itemsCompany () {
      return this.itemsCompanyList.filter(post => {
        return post.company_head.toLowerCase().includes(this.CompanyOwner.toLowerCase())
      })
    }
  },
  methods: {
    closecreate_company (value) {
      this.dialogcreate_company = value
      this.getCompanyMaintenance()
    },
    gotodetail () {
      // console.log('gotodetail')
      this.$router.push('/information_qrcode?id=' + this.generate_id)
    },
    successQrcode () {
      this.showSuccess = false
      this.radioGroup = 0
      this.qrcode = []
      this.CompanyMaintenance = ''
      this.SerialNum = ''
      this.NumQRcode = 1
      this.ExpireBatPicker = new Date().toISOString().substr(0, 7)
      this.ExpirePadPicker = new Date().toISOString().substr(0, 7)
      this.generate_id = ''
      if (this.typeCompanyDecode == 'owner') {
        this.CompanyOwner = this.$store.state.key_object.idCompany
      }
    }, 
    CreateQRcode () {
      this.$swal({
        title: '<div class="Kanit">ยืนยันการสร้าง Qrcode</div>',
        // html: '<b class="Kanit">ยืนยันการสร้าง Qrcode</b><br><b class="Kanit">ยืนยันการสร้าง Qrcode</b>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          if (this.radioGroup == 1) {
            var body = {
              company_owner_id: this.CompanyOwner,
              company_maintenance_id: this.CompanyMaintenance,
              serial_number: this.SerialNum,
              pad_expire: this.ExpirePad,
              battery_expire: this.ExpireBat
            }
            this.$api.genQrCodeByDetail(body).then((response) => {
              if (response.data.message === 'serial_number_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'Serial Number ซ้ำกับในระบบ', 'error' )
              } else if (response.data.message === 'success') {
                this.qrcode = [response.data.data]
                this.generate_id = response.data.data.generate_id
                this.showSuccess = true
              }
            })
          } else if (this.radioGroup == 2) {
            var body = {
              company_owner_id: this.CompanyOwner,
              company_maintenance_id: this.CompanyMaintenance,
              number_qr_code_create: this.NumQRcode,
              pad_expire: this.ExpirePad,
              battery_expire: this.ExpireBat
            }
            this.$api.genQrCodeByNumber(body).then((response) => {
              if (response.data.message === 'success') {
                this.qrcode = response.data.data
                this.generate_id = response.data.data[0].generate_id
                this.showSuccess = true
              }
            })
          }
        }
      })
    },
    getCompanyMaintenance () {
      this.$api.getCompanyMaintenance().then((response) => {
        // console.log(response.data.data)
        this.itemsCompanyList = response.data.data
      })
    },
    getCompanyOwner () {
      this.$api.getCompanyOwner().then((response) => {
        // console.log(response.data.data)
        this.itemsCompanyOwner = response.data.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
>>>.v-menu__content .v-list-item__title {
  font-size: 16px !important;
  font-weight: normal !important;
  line-height: 34px !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
>>>.v-input--selection-controls .v-radio>.v-label {
  color: black;
}
.pd-10 {
  padding: 10px !important;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #a80e00;
  margin-bottom: 10px;
  text-align: left;
}
.form-card-fixed {
  /* min-height: 520px;
  max-height: 520px; */
  /* display: flex;
  flex-direction: column; */
}
.form-content-scrollable {
  overflow-y: auto;
  height: 200px;
  padding-right: 5px;
}
.no-selection-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 150px;
  text-align: center;
}
.form-content-scrollable::-webkit-scrollbar {
  width: 8px;
}
.form-content-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.form-content-scrollable::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.form-content-scrollable::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.toolbarqrcode {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}

.widthdivstep {
    width: 55vw;
    margin-top: 10px;
  }

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .widthdivstep {
    width: 86vw;
    margin-top: 10px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/genqrcode.vue